import './Balance.css';
import api from '../api.js';
import { useEffect, useState } from "react";
import edit from "../imgs/pen.svg";
import historyLogo from "../imgs/history.svg";

export default function Balance() {
    const me = JSON.parse(localStorage.getItem("me") || "{}");
    const role = me?.userInfo?.role;

    // const token = localStorage.getItem("token");

    const headers = {
        // Authorization: `Bearer ${token}`
    };

    const [partners, setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState("");
    const [balance, setBalance] = useState(null);
    const [error, setError] = useState(" ");
    const [loading, setLoading] = useState(false);
    const [balances, setBalances] = useState([]);

    const [innerBalance, setInnerBalance] = useState(null);
    const [innerBalances, setInnerBalances] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [editingPartner, setEditingPartner] = useState(null);
    const [newBalance, setNewBalance] = useState("");

    const [modalError, setModalError] = useState("");
    const [modalMessage, setModalMessage] = useState("");
    const [editingPartnerBalance, setEditingPartnerBalance] = useState(null);
    const [history, setHistory] = useState([]);

    const [historyFilter, setHistoryFilter] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const [historyFromDate, setHistoryFromDate] = useState(today);
    const [historyToDate, setHistoryToDate] = useState(today);

    const openEditModal = (partner) => {
        const inner = innerBalances.find(
            ib => ib.partnerName === partner.partnerName
        );

        setSelectedPartner(partner);
        setNewBalance(inner?.balance ?? 0);

        setModalError("");
        setModalMessage("");
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPartner(null);
        setNewBalance("");
        setModalError("");
        setModalMessage("");
    };

    const OpenHistoryModal = (partner) => {
        setSelectedPartner(partner);
        setIsHistoryOpen(true);
        setModalError("");
        setModalMessage("");
        fetchInnerBalanceHistory(partner.partnerName);
    };

    const CloseHistoryModal = () => {
        setIsHistoryOpen(false);
        setSelectedPartner(null);
        setModalError("");
        setModalMessage("");
        setHistory([]);
        setHistoryFromDate(today);
        setHistoryToDate(today);
        setHistoryFilter("");
    };

    const fetchPartners = async () => {
        try {
            const res = await api.get("/api/partners/list", { headers });
            setPartners(res.data);
            setError("");
        } catch (e) {
            console.error(e);
            setError("Ошибка при загрузке партнеров");
        }
    };

    const updateBalance = async () => {
        try {
            await api.patch("/api/balance/set-balance", null, {
                params: {
                    partnerName: selectedPartner.partnerName,
                    newBalance: parseFloat(newBalance)
                }
            });

            closeModal();
            fetchBalances();
            fetchInnerBalances();

            if (selectedPartner?.partnerName) {
                fetchBalance(selectedPartner.partnerName);
            }
        } catch (e) {
            console.error(e);
            setModalError("Ошибка при обновлении баланса");
        }
    };

    const fetchBalance = async (partnerName) => {
        setLoading(true);
        setError("");
        setBalance(null);

        try {
            const res = await api.get("/api/balance/list-balances", {
                headers,
                params: partnerName ? { partnerName } : {}
            });

            setBalance(res.data);
            setError("");
        } catch (e) {
            if (e.response?.status === 409) {
                setError("Ваша учетная запись не привязана к партнеру");
            } else if (e.response?.status === 404) {
                setError("Баланс не найден");
            } else {
                setError("Ошибка при загрузке баланса");
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchInnerBalance = async (partnerName) => {
        setLoading(true);
        setError("");
        setInnerBalance(null);

        try {
            const res = await api.get("/api/balance/inner-balances", {
                headers,
                params: partnerName ? { partnerName } : {}
            });

            setInnerBalance(res.data);
            setError("");
        } catch (e) {
            if (e.response?.status === 404) {
                setError("Баланс не найден");
            } else {
                setError("Ошибка при загрузке баланса");
            }
        } finally {
            setLoading(false);
        }
    }

    const fetchInnerBalanceHistory = async (partnerName) => {
        setLoading(true);
        setError("");
        setInnerBalance(null);

        try {
            const res = await api.get("/api/balance/balance-history", {
                headers,
                params: partnerName ? { partnerName } : {}
            });

            setHistory(res.data);
            setError("");
        } catch (e) {
            setError("Ошибка при загрузке истории баланса");
        } finally {
            setLoading(false);
        }
    }

    const fetchInnerBalances = async () => {
        setLoading(true);
        setError("");
        setInnerBalances(null);

        try {
            const res = await api.get("/api/balance/inner-balances", {
                headers
            });

            setInnerBalances(res.data);
            setError("");
        } catch (e) {
            if (e.response?.status === 404) {
                setError("Не удалось найти балансы");
            } else {
                setError("Ошибка при загрузке балансов");
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!role) return;

        if (role === "Админ") {
            fetchPartners();
        }

        if (role === "Партнер") {
            fetchInnerBalance();
        }
    }, [role]);

    const handleSelectChange = (e) => {
        const partnerName = e.target.value;
        setSelectedPartner(partnerName);

        if (partnerName) {
            fetchBalance(partnerName);
        }
    };

    const fetchBalances = async () => {
        setError("");
        setLoading(true);
        try {
            // const token = localStorage.getItem("token");
            const res = await api.get("/api/balance/list-all-balances", {
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            setBalances(Array.isArray(res.data) ? res.data : [res.data]);
        } catch (err) {
            const status = err.response?.status;
            const data = err.response?.data;

            if (status === 409) {
                setError(typeof data === "string" ? data : "Ваша учетная запись не привязана к партнеру");
            }
            else {
                setError("Ошибка при загрузке балансов");
            }
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        document.title = "Баланс - Wave";
        if (role === "Админ") {
            fetchBalances();
            fetchInnerBalances();
        }
    }, [role]);

    const uniqueHistoryTypes = [...new Set(history.map(h => h.changeType))];

    // const filteredHistory = historyFilter
    //     ? history.filter(h => h.changeType === historyFilter)
    //     : history;

    const filteredHistory = history.filter(h => {
        const date = new Date(h.dateTime);
        const from = historyFromDate ? new Date(historyFromDate) : null;
        const to = historyToDate ? new Date(historyToDate + "T23:59:59") : null;
        return (!historyFilter || h.changeType === historyFilter)
            && (!from || date >= from)
            && (!to || date <= to);
    });


    return (
        <div className="balances-main">
            <h1>Баланс</h1>

            {role === "Админ" && (
                <select
                    value={selectedPartner}
                    onChange={handleSelectChange}
                    className="select-button"
                >
                    <option value="">Выберите партнера</option>
                    {partners.map((p) => (
                        <option key={p.id} value={p.name}>
                            {p.name}
                        </option>
                    ))}
                </select>
            )}

            <div className="tableWrapper">
                <table className={role === "Админ" ? "tableAdmin" : "tablePartner"}>
                    <thead>
                        <tr>
                            <th>Партнер</th>
                            <th>Баланс</th>

                            {role === "Админ" && (
                                <>
                                    <th>Баланс WAve</th>
                                    <th></th>
                                </>
                            )}

                            <th>Последнее обновление</th>

                            {role === "Админ" && (
                                <>
                                    <th></th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>...</tr>
                        ) : role === "Партнер" && innerBalance ? (
                            (Array.isArray(innerBalance) ? innerBalance : [innerBalance]).map((ib, i) => (
                                <tr key={i}>
                                    <td>{ib.partnerName}</td>
                                    <td>{ib.balance}</td>
                                    <td>
                                        {ib.lastChange
                                            ? new Date(ib.lastChange).toLocaleString()
                                            : "-"}
                                    </td>
                                </tr>
                            ))
                        ) : balance ? (
                            <tr>
                                <td>{balance.partnerName}</td>
                                {role === "Админ" && (
                                    <td>{balance.balance}</td>
                                )}
                                <td>
                                    {innerBalances.find(
                                        ib => ib.partnerName === balance.partnerName
                                    )?.balance || "-"}
                                </td>
                                {role === "Админ" && (
                                    <td>
                                        <button
                                            className="edit-btn"
                                            onClick={() => openEditModal(balance)}
                                        >
                                            Редактировать
                                        </button>
                                        <button
                                            className="edit-btn-mobile"
                                            onClick={() => openEditModal(balance)}
                                        >
                                            <img src={edit} />
                                        </button>
                                    </td>
                                )}
                                <td>{balance.lastUpdated ? new Date(balance.lastUpdated).toLocaleString() : "-"}</td>
                                {role === "Админ" && (
                                    <td>
                                        <button
                                            className="edit-btn"
                                            onClick={() => OpenHistoryModal(balance)}
                                        >
                                            История
                                        </button>
                                        <button className="edit-btn-mobile" onClick={() => OpenHistoryModal(balance)}>
                                            <img src={historyLogo} />
                                        </button>
                                    </td>
                                )}
                            </tr>
                        ) : error && selectedPartner ? (
                            <tr>
                                <td colSpan={role === "Админ" ? 6 : 3} className="error">
                                    {error}
                                </td>
                            </tr>
                        ) : balances.length > 0 ? (
                            balances.map((b, index) => {
                                const inner = innerBalances.find(
                                    ib => ib.partnerName === b.partnerName
                                );

                                return (
                                    <tr key={index}>
                                        <td>{b.partnerName}</td>

                                        {role === "Админ" && (
                                            <td>{b.balance}</td>
                                        )}

                                        <td>{inner ? inner.balance : "-"}</td>

                                        {role === "Админ" && (
                                            <td>
                                                <button
                                                    className="edit-btn"
                                                    onClick={() => openEditModal(b)}
                                                >
                                                    Редактировать
                                                </button><button
                                                    className="edit-btn-mobile"
                                                    onClick={() => openEditModal(b)}
                                                >
                                                    <img src={edit} />
                                                </button>
                                            </td>
                                        )}

                                        <td>
                                            {b.lastUpdated
                                                ? new Date(b.lastUpdated).toLocaleString()
                                                : "-"}
                                        </td>

                                        {role === "Админ" && (
                                            <td>
                                                <button
                                                    className="edit-btn"
                                                    onClick={() => OpenHistoryModal(b)}
                                                >
                                                    История
                                                </button>
                                                <button className="edit-btn-mobile"
                                                    onClick={() => OpenHistoryModal(b)}
                                                >
                                                    <img src={historyLogo} />
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })
                        ) : role === "Админ" && !selectedPartner ?
                            (
                                <tr>
                                    <td colSpan={role === "Админ" ? 6 : 3} style={{ textAlign: "center" }}>Загрузка...</td>
                                </tr>
                            )
                            : (
                                role === "Админ" ? (
                                    <tr>
                                        <td colSpan={role === "Админ" ? 6 : 3} style={{ textAlign: "center" }}>Данные не найдены</td>
                                    </tr>
                                ) :
                                    (
                                        <tr>
                                            <td colSpan={role === "Админ" ? 6 : 3} style={{ textAlign: "center" }}>Данные не найдены</td>
                                        </tr>
                                    )
                            )}
                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <div className="modalOverlay">
                    <div className="modalPartners">
                        <form onSubmit={(e) => { e.preventDefault(); updateBalance(); }}>

                            <div className="modalTop">
                                <h3>Редактирование баланса</h3>
                                <button type="button" onClick={closeModal}></button>
                            </div>

                            <div className="modalInfo">
                                <p>Партнер: <b>{selectedPartner?.partnerName}</b></p>

                                <p>
                                    Текущий баланс WAve:{" "}
                                    <b>
                                        {innerBalances.find(
                                            ib => ib.partnerName === selectedPartner?.partnerName
                                        )?.balance ?? 0}
                                    </b>
                                </p>
                            </div>

                            <input
                                type="number"
                                placeholder="Новый баланс"
                                value={newBalance}
                                onChange={(e) => setNewBalance(e.target.value)}
                            />

                            {error && <p className="error">{error}</p>}

                            <div className="buttonsModal">
                                <button
                                    type="submit"
                                    className="saveChangesPartners"
                                >
                                    Сохранить
                                </button>

                                <button
                                    type="button"
                                    className="cancelPartners"
                                    onClick={closeModal}
                                >
                                    Отмена
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            )}

            {isHistoryOpen && (
                <div className="modalOverlay">
                    <div className="modalPartnersHistory">
                        <div className="modalTop">
                            <h3>История операций по балансу</h3>
                            <button type="button" onClick={CloseHistoryModal}></button>
                        </div>

                        <div className="modalInfoHistory">
                            <p>Партнер: <b>{selectedPartner?.partnerName}</b></p>

                            <p>
                                Текущий баланс WAve:{" "}
                                <b>
                                    {innerBalances.find(
                                        ib => ib.partnerName === selectedPartner?.partnerName
                                    )?.balance ?? 0}
                                </b>
                            </p>
                        </div>
                        <div className="historyFilter">
                            <select
                                value={historyFilter}
                                onChange={(e) => setHistoryFilter(e.target.value)}
                                className="select-button-operation"
                            >
                                <option value="">Все операции</option>

                                {uniqueHistoryTypes.map((type, index) => (
                                    <option key={index} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="date-filter">
                            <label>
                                С:
                                <input
                                    type="date"
                                    value={historyFromDate}
                                    onChange={(e) => setHistoryFromDate(e.target.value)}
                                />
                            </label>
                            <label>
                                По:
                                <input
                                    type="date"
                                    value={historyToDate}
                                    min="1900-01-01"
                                    max="2999-12-31"
                                    onChange={(e) => setHistoryToDate(e.target.value)}
                                />
                            </label>
                        </div>
                        <div className='historyBody'>
                            <div className='history'>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Операция</th>
                                            <th>Сумма</th>
                                            <th>Дата и время</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ?
                                            <tr>
                                                <td colSpan="3" style={{ "textAlign": "center" }}>Загрузка...</td>
                                            </tr> : error ?
                                                <tr>
                                                    <td colSpan="3" className="error">{error}</td>
                                                </tr> : filteredHistory.length > 0 ?
                                                    filteredHistory.map((h, index) => {
                                                        return (
                                                            <tr className='historyLine' key={index}>
                                                                <td>{h.changeType}</td>
                                                                <td>{h.amount}</td>
                                                                <td>{new Date(h.dateTime).toLocaleString()}</td>
                                                            </tr>
                                                        );
                                                    }) :
                                                    <tr>
                                                        <td colSpan="3">История операций пуста</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
